<script>
  // @ts-check
  import { onMount } from "svelte";
  import Image from "../../atoms/Image.svelte";
  import NewsletterConfirmationViewInfo from "./NewsletterConfirmationViewInfo.svelte";
  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * Indicates whether the form submission was successful
   * @type {boolean}
   */
  export let isFormSubmitSuccess = undefined;

  /**
   * The featured image in the card
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the NewsLetter Confirmation
   * @type {string} */
  export let title = undefined;

  /** The subtitle of the NewsLetter Confirmation
   * @type {string} */
  export let subTitle = undefined;

  /**
   * The description of the NewsLetter Confirmation
   * @type {string}
   */
  export let description = null;

  /**
   * The class of this of the content
   * @type {string}
   */
  export let contentClass = null;

  export let containerClass = null;

  /**
   * The call to action of the NewsLetter Confirmation
   * @type {import('../../types/shared.js').CTA}
   */
  export let cta = null;

  let submitSuccessTextElement = undefined;

  const hasFeatureImage = !!featuredImage?.src && !!featuredImage?.alt;

  onMount(() => {
    if (isFormSubmitSuccess) {
      submitSuccessTextElement?.focus();
    }
  });
</script>

<DynamicHeadingContext>
  <div {id} class="relative flex flex-col lg:flex-row {containerClass} min-h-full">
    {#if hasFeatureImage}
      <div class="lg:flex-1">
        <Image {...featuredImage} aspectRatioClasses="aspect-3/4" />
      </div>
    {:else}
      <div class="lg:flex-1 {contentClass}">
        <DynamicHeading
          class="heading-md"
          bind:ref={submitSuccessTextElement}
          tabindex="-1"
          aria-live="assertive"
        >
          {title}
        </DynamicHeading>
      </div>
    {/if}

    <div class="flex flex-1 flex-col {contentClass}">
      {#if hasFeatureImage}
        <div class="flex h-full flex-col justify-between">
          <DynamicHeading
            class="heading-md"
            bind:ref={submitSuccessTextElement}
            tabindex="-1"
            aria-live="assertive"
          >
            {title}
          </DynamicHeading>
          <div class="h-[50%]">
            <NewsletterConfirmationViewInfo id="confirmation-page" {subTitle} {cta} {description} />
          </div>
        </div>
      {/if}
      <div>
        {#if !hasFeatureImage}
          <div>
            <NewsletterConfirmationViewInfo id="confirmation-page" {subTitle} {cta} {description} />
          </div>
        {/if}
      </div>
    </div>
  </div>
</DynamicHeadingContext>
